import { Typography } from "@sunday/component";
import styled from "styled-components";

export const PrivacyPageContainer = styled.main`
  --color-text-ci: var(--colors-system-primitive-color-ic-blueneon-50, #435dff);
  --typography-bg-color-selection: var(--color-text-ci);
  --typography-color-selection: var(--color-text-on-primary, #ffffff);
  --typescale-font-head: var(--typeface-font-ic-en, "JUST Sans"),
    var(--typeface-font-ic-th, "Noto Sans Thai"), sans-serif;
  --typescale-font-base: var(--typeface-font-ic-th, "Noto Sans Thai"),
    var(--typeface-font-ic-en, "JUST Sans"), sans-serif;

  background: var(--color-surface-primary, #ffffff);

  && *::selection {
    background-color: var(--typography-bg-color-selection) !important;
    color: var(--typography-color-selection) !important;
  }
`;

export const PrivacyContentContainer = styled.div`
  width: 100%;
  max-width: 1388px;
  margin: 0 auto;
  padding: 80px 0;

  @media (max-width: 767px) {
    padding: 40px 16px 24px;
  }
`;

export const PrivacyContent = styled.div`
  width: 100%;
  max-width: 803px;
  margin: 0 auto;
`;

export const PrivacyTitle = styled(Typography.Display).attrs({
  designLevel: 3,
  weight: "bold",
  level: 1,
})`
  && {
    display: block;
    margin: 0 0 24px;
    color: var(--color-text-primary, #202123);
    font-style: normal;
    word-break: break-word;
  }

  @media (max-width: 767px) {
    && {
      --typography-d3-font-size: var(--typescale-size-h-1, 28px);
      --typography-d3-line-height: var(--typescale-line-height-h-1, 36px);
    }
  }
`;

export const PrivacyArticle = styled.article`
  color: var(--color-text-secondary, #5f6468);
  font-family: var(--typescale-font-th, "Noto Sans Thai"), sans-serif;
  font-size: var(--typescale-size-b-2, 15px);
  font-style: normal;
  font-weight: 350;
  line-height: var(--typescale-line-height-b-2, 24px);
  letter-spacing: var(--typescale-tracking-base, 0);
  word-break: break-word;

  h2,
  p,
  ul {
    font: inherit;
  }

  h2 {
    margin: 0;
    color: inherit;
    font-weight: 700;
  }

  p,
  ul {
    margin: 0 0 24px;
  }

  ul {
    padding-left: 22px;
  }

  li {
    margin: 0;
    padding: 0;
  }

  a {
    color: var(--color-text-ci, #435dff);
    font-weight: 700;
    text-decoration: underline;
    text-decoration-skip-ink: none;
    text-underline-position: from-font;
  }

  section:last-child > :last-child {
    margin-bottom: 0;
  }
`;
